// ======================================================================
// File Name       : ServiceGroupTopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import PropTypes from 'prop-types';
import React from 'react';
import { Col, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as serviceGroupActions from '../../actions/ServiceGroupAction';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import ModalConductor from '../../components/modal/ModalConductor';
import * as ICON from '../../constants/IconConstants';
import * as Path from '../../constants/PathConstants';
import { RETURN_MAX_NUM_1000, WRITE } from '../../constants/index';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { SERVICE_GROUP_REGISTER } from '../../constants/FunctionConstants';

class ServiceGroupTopContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      serviceGroupListInfo: [],
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM_1000,
    };
    this.onSearchData = this.onSearchData.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
  }

  componentDidMount() {
    this.onSearchData();
  }

  static getDerivedStateFromProps(nextProps, state) {
    const { serviceGroup: { serviceGroupListInfo } } = nextProps;
    if (state.serviceGroupListInfo !== serviceGroupListInfo) {
      return {
        ...state,
        serviceGroupListInfo,
      };
    }
    return state;
  }

  onSearchData() {
    this.setState({
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM_1000,
    },
    () => this.getServiceGroupList());
  }

  getServiceGroupList() {
    const param = {
      startPosition: this.state.startPosition,
      returnMaxNum: this.state.returnMaxNum,
    };

    this.props.dispatch(serviceGroupActions.getServiceGroupList(param));
  }

  handleRegister(menuData, { callbackData = {} } = {}) {
    const { dispatch } = this.props;
    dispatch(serviceGroupActions.resetInitData());
    dispatch(serviceGroupActions.openServiceGroupRegisterDialog());
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { serviceGroupListInfo } = this.state;
    const { isBelongServiceGroup } = this.props;
    const serviceGroupList = serviceGroupListInfo.serviceGroupList.map((serviceGroup, index) => {
      const link = Path.SERVICE_GROUP_DETAIL.replace(':id', serviceGroup.serviceGroupSecernId);
      return (
        <tr
          key={serviceGroup.serviceGroupSecernId}
          onMouseEnter={() => this.handleMouseEnter(index)}
          onMouseLeave={() => this.handleMouseLeave()}
        >
          <td>{serviceGroup.serviceGroupName}</td>
          <td className="text-center">
            <CustomLink
              className="margin-right-7 link-detail"
              to={link}
              text="詳細を見る"
            />
          </td>
        </tr>
      );
    });

    return (
      <div>
        <Header name="サービスグループ" />
        {!isBelongServiceGroup && canAccessRoute(SERVICE_GROUP_REGISTER) && (
          <Col sm={12} className="padding-left-right-clear inline-flex margin-bottom-10">
            <CustomLink
              className="margin-right-7 btn-register"
              onClick={this.handleRegister}
              text="サービスグループ追加"
              icon={ICON.REGIST}
            />
          </Col>
        )}
        <Col className="padding-left-right-clear">
          <Table striped hover>
            <thead>
              <tr>
                <th>サービスグループ名</th>
                <th width="150">操作</th>
              </tr>
            </thead>
            <tbody>
              {serviceGroupList}
            </tbody>
          </Table>
        </Col>
        <ModalConductor
          history={this.props.history}
        />
      </div>
    );
  }
}

ServiceGroupTopContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
};
const mapStateToProps = (state, ownProps) => ({
  ...{
    serviceGroup: state.serviceGroup,
    auth: state.authed.authedUser.userInfo,
    isBelongServiceGroup: state.authed.authedUser.isBelongServiceGroup
  },
});

export default connect(mapStateToProps)(ServiceGroupTopContainer);
